globalThis.backoffice = globalThis.backoffice || {};

backoffice.formSubmitAjax = (function() {
    function formSubmitAjax($html) {
        this.$html = $html;
        this.init();
    }

    formSubmitAjax.prototype = {
        init: function() {
          var me = this;
          var wto;

          me.$html.on('submit', function(e){
            e.preventDefault();
            var $form = $(this);
            var ajaxSubmitOptions = $form.data("ajax-submit-options");

            if(ajaxSubmitOptions != undefined && ajaxSubmitOptions["loader_mode"] == 'local'){
              var ajaxSavingContainer = ajaxSubmitOptions['loader_container_selector'] ? $(ajaxSubmitOptions['loader_container_selector']) : $form;
              var ajaxSavedContainer = ajaxSubmitOptions['loader_container_selector'] ? $(ajaxSubmitOptions['loader_container_selector']) : $form;

              var $formSubmitAjaxSaving = ajaxSavingContainer.find('.form-submit-ajax-saving');
              var $formSubmitAjaxSaved = ajaxSavedContainer.find('.form-submit-ajax-saved');

              $formSubmitAjaxSaving.show();
              $formSubmitAjaxSaved.hide();

              if(ajaxSubmitOptions["timeout"]){
                var timeout = 500;
              } else {
                var timeout = 0;
              }

              clearTimeout(wto);
              wto = setTimeout(function() {
                $.post($form.attr('action'), $form.serialize(), function(data) {
                  if(data.response == 1) {
                    $formSubmitAjaxSaving.hide();
                    $formSubmitAjaxSaved.show();
                    $form[0].dispatchEvent(new CustomEvent('ajax-submit-success', { detail: data }))
                  } else {
                    $formSubmitAjaxSaving.hide();
                    $formSubmitAjaxSaved.hide();
                  }

                  if (ajaxSubmitOptions['with_refresh'] == true) {
                    window.location.reload();
                  }
                }, 'json')
              }, timeout);

            } else {
              backoffice.loader.start();
              $.post($form.attr('action') + '.json', $form.serialize(), function(data) {
                backoffice.loader.finish();
                if(data.response) {
                  new PNotify({icon: 'icon-checkmark3', title: "Mise à jour réussie", type: 'success'});
                } else {
                  new PNotify({icon: 'icon-cross2', title: "Erreur lors de la mise à jour", type: 'error'});
                }
              }).fail(function() {
                backoffice.loader.finish();
                new PNotify({icon: 'icon-cross2', title: "Erreur serveur", type: 'error'});
              });
            }
          });
        }
    }

    return formSubmitAjax;
})();
